<template>
    <b-card class="shadow">
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h5 class="mb-0 text-gray-800">
                        {{ $t("Unidades de Acolhimento e Vagas") }}
                    </h5>
                    <b-button-group>
                        <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                        >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                        </b-button>
                        <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                        </b-button>
                        <b-button
                            variant="outline-dark"
                            @click="exportar()"
                            :title="$t('Exportar')"
                            v-b-tooltip.hover
                        >
                            <i class="fas fa-file-excel"></i>
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div class="col-12" v-if="viewFilterReport">
                <!-- Filtros -->
                <form @submit.prevent="getAnalytics" ref="addItem">
                    <div class="row">
                        <form-calendar
                            v-model="data_inicio"
                            grid="3"
                            label="Data inicial"
                            :max-date="dataNow"
                        />

                        <form-calendar
                            v-model="data_fim"
                            grid="3"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                            :max-date="dataNow"
                        />

                        <form-select
                            v-model="filtroNatureza"
                            label="Natureza"
                            grid="6"
                            :itens="$root.arrays.acolhimento_naturezas"
                            multiple
                        />

                        <form-select
                            v-model="filtroPublicoAlvo"
                            label="Público-alvo"
                            grid="12"
                            :itens="$root.arrays.acolhimento_publico_alvo"
                            multiple
                        />

                        <form-select
                            v-model="filtroUnidades"
                            label="Unidade(s)"
                            grid="6"
                            :itens="unidades"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            multiple
                        />
                        <form-select
                            v-model="filtroSubtipos"
                            label="Subtipo da Unidade"
                            grid="6"
                            :itens="subtipos"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            multiple
                        />

                        <div class="col-md-12 mb-5">
                            <label><b>Vagas Disponíveis</b></label>
                            <vue-slider
                                v-model="filtroVagas"
                                :min="min"
                                :max="max"
                                :tooltip="'always'"
                                :tooltip-placement="'bottom'"
                            ></vue-slider>
                        </div>

                        <div class="col-md-12 mb-3">
                            <label><b>Vagas Ocupadas</b></label>
                            <vue-slider
                                v-model="filtroVagasOcupadas"
                                :min="min_ocupadas"
                                :max="max_ocupadas"
                                :tooltip="'always'"
                                :tooltip-placement="'bottom'"
                            ></vue-slider>
                        </div>
                    </div>
                    <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                        <div class="col-auto px-2 text-right">
                            <button
                                class="btn btn-default"
                                @click.prevent="
                                    limparFiltros, (viewFilterReport = false)
                                "
                            >
                                <i class="fas fa-times"></i>
                            </button>

                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click.prevent="limparFiltros()"
                            >
                                {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                                class="btn btn-success btn-submit"
                                data-style="zoom-in"
                                type="submit"
                            >
                                <i class="fas fa-chart-bar"></i>
                                {{ $t("Gerar Relatório") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <loading-report
                :loading="isLoadingMsg"
                mensagem="Por favor aguarde estamos realizando sua solicitação..."
                icone="fa-smile-wink"
            ></loading-report>

            <div class="col-md-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />

                <print-content>
                    <template v-slot:datas>
                        <p
                            class="d-flex align-items-center justify-content-between mb-4"
                        >
                            <span
                                >Período selecionado:
                                <b>{{ datas.start }} - {{ datas.end }}</b>
                                <b-link
                                    href="#"
                                    @click.prevent="void 0"
                                    class="mb-2"
                                    variant="info"
                                    v-b-popover.hover.top="
                                        'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                                    "
                                >
                                    <i class="fas fa-info-circle"></i> </b-link
                            ></span>

                            <span v-if="pagination.total"
                                >Total de Registros <b>{{ pagination.total }}</b
                                >, total por página
                                <b>{{ pagination.perPage }}</b></span
                            >
                        </p>
                    </template>
                    <b-table
                        :fields="[
                            {
                                key: 'unidade_nome',
                                label: $t('Unidade'),
                            },
                            {
                                key: 'publico_alvo',
                                label: $t('Público-alvo'),
                            },
                            {
                                key: 'subtipo',
                                label: $t('Subtipo'),
                            },
                            {
                                key: 'vagas_disponiveis',
                                label: $t('Vagas Disponíveis'),
                            },
                            {
                                key: 'vagas_ocupadas',
                                label: $t('Vagas Ocupadas'),
                            },
                            {
                                key: 'created_at',
                                label: $t('Criado em'),
                            },
                        ]"
                        :items="itensList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="xs"
                        table-class="mb-3"
                    >
                        <template v-slot:cell(unidade_nome)="data">
                            <b>{{ data.item.unidade_nome }}</b>
                            <span
                                class="d-block small"
                                v-if="data.item.natureza"
                            >
                                Natureza:
                                <b>{{
                                    getNatureza(
                                        data.item.natureza,
                                        $root.arrays.acolhimento_naturezas
                                    )
                                }}</b>
                            </span>
                        </template>
                        <template v-slot:cell(publico_alvo)="data">
                            <strong
                                v-for="(publico, i) in data.item.publico_alvo"
                                :key="i"
                                v-html="
                                    getPublicoAlvo(
                                        publico,
                                        $root.arrays.acolhimento_publico_alvo
                                    )
                                "
                            >
                            </strong>
                        </template>
                        <template v-slot:cell(subtipo)="data">
                            <small
                                class="d-block font-weight-bold"
                                v-if="data.item.unidade"
                            >
                                {{ data.item.unidade.subtipo_nome }}
                            </small>
                        </template>
                        <template v-slot:cell(vagas_disponiveis)="data">
                            {{ data.item.vagas_disponiveis }}
                        </template>
                        <template v-slot:cell(vagas_ocupadas)="data">
                            {{ data.item.vagas_ocupadas }}
                        </template>
                        <template v-slot:cell(created_at)="data">
                            {{ data.value | formatDate }}
                        </template>
                        <template v-slot:empty="scope">
                            <div class="text-center my-5">
                                <img
                                    :alt="$t('No results')"
                                    class="mb-5"
                                    src="/img/icons/robot.svg"
                                    style="max-height: 165px"
                                />
                                <h3 class="bold">
                                    {{ $t("No records found") }}
                                </h3>
                            </div>
                        </template>
                    </b-table>
                </print-content>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                class="form-control"
                                style="width: 70px"
                                v-model="perPage"
                                v-on:change="getAnalytics"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                :per-page="perPage"
                                :total-rows="pagination.total"
                                @change="changePage"
                                v-model="page"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }} {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>

                <div class="box-btn-print no-print">
                    <b-button
                        v-if="!loading"
                        :title="$t('Visualizar e Imprimir')"
                        class="py-2"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                        @click="print()"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "HomeReportUnidadesAcolhimento",
    data() {
        return {
            loading: true,
            loadingSearchUnidade: true,
            desabledSearchUnidade: true,
            itensList: [],
            unidades: [],
            page: 1,
            search: "",
            perPage: 10,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            isLoadingMsg: false,
            datas: [],
            filtroNatureza: [],
            filtroUnidades: [],
            filtroSubtipos: [],
            filtroDatas: [],
            filtroVagas: [0, 50],
            filtroVagasOcupadas: [0, 50],
            filtroPublicoAlvo: [],
            subtipos: [],
            datas: [],
        };
    },
    created() {
        this.min = 0;
        this.max = 50;
        this.min_ocupadas = 0;
        this.max_ocupadas = 50;
        this.enableCross = false;
    },
    mounted() {
        this.getVagasMaximas();
        this.getUnidades();
        this.getAnalytics();
    },
    methods: {
        filterData(value) {
            return this.$options.filters.formatDateHora(value);
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getAnalytics();
            }
        },
        getAnalytics() {
            this.isLoadingMsg = true;
            this.loading = true;

            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }

            axios
                .get("api/dashboard/report/acolhimentos/home", {
                    params: {
                        page: this.page,
                        filtroSearch: this.search,
                        perPage: this.perPage,
                        filtroUnidades: this.filtroUnidades,
                        filtroDatas: this.filtroDatas,
                        filtroSubtipos: this.filtroSubtipos,
                        vagas: this.filtroVagas,
                        vagasOcupadas: this.filtroVagasOcupadas,
                        publicoAlvo: this.filtroPublicoAlvo,
                        filtroNatureza: this.filtroNatureza,
                    },
                })
                .then((response) => {
                    this.loading = false;
                    this.datas = response.data.datas;
                    this.itensList = response.data.dados.original.data;
                    this.pagination = response.data.dados.original.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getAnalytics();
                    } else {
                        this.isLoadingMsg = false;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.isLoadingMsg = false;
                    this.loading = false;
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            this.desabledSearchUnidade = true;
            axios
                .get(`api/dashboard/report/acolhimentos/home`)
                .then((response) => {
                    this.unidades = response.data.dados.original.data.map(
                        (elem) => ({
                            id: elem.unidade_id,
                            value: " <b>" + elem.unidade_nome + "</b> ",
                        })
                    );

                    const subtipos = response.data.dados.original.data.map(
                        (elem) => ({
                            id: elem.unidade.subtipo.id,
                            value: elem.unidade.subtipo.descricao,
                        })
                    );

                    this.subtipos = Array.from(
                        new Set(subtipos.map((a) => a.id))
                    ).map((id) => {
                        return {
                            id: id,
                            value: subtipos.find((a) => a.id === id).value,
                        };
                    });
                })
                .finally(() => {
                    this.loadingSearchUnidade = false;
                    this.desabledSearchUnidade = false;
                });
        },
        exportar() {
            this.isLoadingMsg = true;
            this.loading = true;
            swal.fire({
                title: "Aguarde! O Arquivo está sendo gerado.",
                text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
                imageUrl: `${window.urlbase}img/load.gif`,
                showConfirmButton: false,
            });
            axios
                .get("api/dashboard/acolhimentos/unidades", {
                    params: {
                        page: this.page,
                        filtroSearch: this.search,
                        perPage: this.perPage,
                        filtroUnidades: this.filtroUnidades,
                        filtroDatas: this.filtroDatas,
                        filtroSubtipos: this.filtroSubtipos,
                        vagas: this.filtroVagas,
                        vagasOcupadas: this.filtroVagasOcupadas,
                        publicoAlvo: this.filtroPublicoAlvo,
                        filtroNatureza: this.filtroNatureza,
                        export: "ok",
                    },
                })
                .then((response) => {
                    this.isLoadingMsg = false;
                    this.loading = false;

                    swal.fire({
                        title: "Arquivo Pronto para Download!",
                        html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
                        icon: "success",
                        showConfirmButton: false,
                    });
                })
                .finally(() => {
                    (this.isLoadingMsg = false), (this.loading = false);
                });
        },
        limparFiltros() {
            //   this.filtros = {};
            this.search = "";
            this.data_inicio = null;
            this.data_fim = null;

            this.filtroNatureza = [];
            this.filtroUnidades = [];
            this.filtroSubtipos = [];
            this.filtroDatas = [];
            this.filtroVagas = [];
            this.filtroVagasOcupadas = [];
            this.filtroPublicoAlvo = [];

            this.getAnalytics();
            this.getVagasMaximas();
        },

        getPublicoAlvo(value, array) {
            const result = array.filter((item) => item.id == value);
            return result[0]
                ? `<small class="d-block font-weight-bold">${result[0].value}</small>`
                : "";
        },
        getNatureza(value, array) {
            const result = array.filter((item) => item.id == value);
            return result[0] ? result[0].value : "";
        },
        getTipoPublicoAlvo(alvo) {
            if (alvo != null) {
                let tipo = false;
                for (var i = 0; i < alvo.length; i++) {
                    if (alvo[i] == 1 || alvo[i] == 2) {
                        tipo = "crianca";
                    } else if (alvo[i] == 8) {
                        tipo = "idoso";
                    }
                }
                return tipo;
            }
        },
        getVagasMaximas() {
            axios
                .get(
                    "api/dashboard/report/acolhimentos/unidades/get/vagasmaximas"
                )
                .then((response) => {
                    this.max = response.data.vagas;
                    this.max_ocupadas = response.data.vagas;
                    this.filtroVagas = [0, this.max];
                    this.filtroVagasOcupadas = [0, this.max_ocupadas];
                    this.getAnalytics();
                });
        },
    },
};
</script>
